var __TEMP__ = require('./_baseFunctions.js');var baseFunctions = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./keysIn.js');var keysIn = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates an array of function property names from own and inherited
 * enumerable properties of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @returns {Array} Returns the function names.
 * @see _.functions
 * @example
 *
 * function Foo() {
 *   this.a = _.constant('a');
 *   this.b = _.constant('b');
 * }
 *
 * Foo.prototype.c = _.constant('c');
 *
 * _.functionsIn(new Foo);
 * // => ['a', 'b', 'c']
 */
function functionsIn(object) {
  return object == null ? [] : baseFunctions(object, keysIn(object));
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = functionsIn;
